import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Phonics Grand Prix',
    description: 'A 3D phonics racing adventure for Year 1. Blend CVC words, upgrade your race car and win the Phonics Grand Prix.',
    placeholder: 'Your new site will appear right here. Just ask Modulify to generate anything you can describe.',
    url: getOrigin()
}